import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncatedText'
})
export class TruncatedTextPipe implements PipeTransform {

  transform(value: string, max: number): string {
    const length = value.length;
    return length < max ? value : value.substring(0, max - 3) + '...';
  }

}
